import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import skillookAdmin from 'apis/skillookAdmin';
import { mapKeys, omit } from 'lodash';

// First, create the thunk

// Get All Skills Request with search Functionality

export const allSkillsListRequest = createAsyncThunk(
  'allSkillsList',
  async body => {
    const [start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/skills/allSkillNames?skip=${start}&limit=${limit}`
    );
    return response.data.data;
  }
);

// Get All Skills Request with search Functionality

export const searchSkillsListRequest = createAsyncThunk(
  'searchSkillsList',
  async body => {
    const [keyword, start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/skills/search?limit=${limit}&skip=${start}&keyword=${keyword}`
    );
    return { skip: start, data: response.data.data };
  }
);

// Add New Skills

export const addNewSkillRequest = createAsyncThunk(
  'addNewSkill',
  async body => {
    const response = await skillookAdmin.post(
      `admin/users/skills/addSkillName`,
      body
    );
    return response.data.data;
  }
);

// Get Single Skill Details

export const getSingleSkillRequest = createAsyncThunk(
  'getSingleSkill',
  async body => {
    const response = await skillookAdmin.post(
      `admin/users/skills/singleSkillName`,
      body
    );
    return response.data.data;
  }
);

// Delete Skill Request

export const deleteSkillRequest = createAsyncThunk(
  'deleteSkill',
  async body => {
    await skillookAdmin.post(`admin/users/skills/deleteSkillName`, body);
    return body.id;
  }
);

// Update Skill Details Request

export const updateSkillRequest = createAsyncThunk('update', async body => {
  await skillookAdmin.post(`admin/users/skills/updateSkillName`, body);
  return body;
});

// Then, handle actions in your reducers:
const skillsListSlice = createSlice({
  name: 'allSkillsList',
  initialState: { list: {}, totalCount: 0, singleSkillData: null },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllSkillList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [allSkillsListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: { ...state.list, ...mapKeys(action.payload.skillList, '_id') },
        totalCount: action.payload.totalSkillsCount,
      };
    },
    [searchSkillsListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list:
          action.payload.skip === 0
            ? { ...mapKeys(action.payload.data.skillList, '_id') }
            : {
                ...state.list,
                ...mapKeys(action.payload.data.skillList, '_id'),
              },
        totalCount: action.payload.data.totalSkillsCount,
      };
    },
    [addNewSkillRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload._id]: {
            _id: action.payload._id,
            skillName: action.payload.skillName,
          },
        },
      };
    },
    [getSingleSkillRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        singleSkillData: action.payload,
      };
    },
    [deleteSkillRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: omit(state.list, action.payload),
        singleSkillData: null,
      };
    },
    [updateSkillRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload.id]: {
            ...state.list[action.payload.id],
            skillName: action.payload.skillName,
          },
        },
      };
    },
  },
});

export const { emptyAllSkillList } = skillsListSlice.actions;
export default skillsListSlice.reducer;
